export interface IBreakpoints {
    [key: string]: number;
}

export const layoutPageContentWidth: number = 1260;

export const Breakpoints: IBreakpoints = {
    desktop: 768,
    largeScreen: 1024,
    extraLargeScreen: 1200
};

export const breakpoint = (brp: string) => (
    code: TemplateStringsArray,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...placeholders: any[]
) => {
    // interleave the code with the placeholders
    let result = placeholders.reduce((acc, holder, idx) => `${acc}${code[idx]}${holder}`, '');

    // add the code literal
    result = `${result}${code[code.length - 1]}`;

    return `@media(min-width: ${Breakpoints[brp]}px) {${result}}`;
};
